import styled from "@emotion/styled";

import { fontMerriweather, theme } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: grid;
  grid:
    "cover-image" min-content
    "headline" min-content
    / 100%;
  gap: 12px;

  ${theme.breakpoints.between("tablet", "desktop")} {
    grid: "headline cover-image" min-content / minmax(260px, 338px) minmax(400px, 590px);
    gap: 32px;
  }
`;

export const StyledEntityLink = styled(EntityLink)``;

export const Headline = styled.div`
  grid-area: headline;

  color: #000000;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 140%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 22px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 15px;
  }
`;

export const CoverImage = styled.div`
  grid-area: cover-image;
  ${Figure} {
    aspect-ratio: 16/9;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
`;
